const EN_DASH = '–';
/** «XV70 рестайлинг (2020–2024)», «XV80, Китай (с 2023)», «E36 (1990)». */
export const formatGenerationDisplay = ({ label, yearFrom, yearTo }) => {
    if (yearTo === null)
        return `${label} (с ${yearFrom})`;
    if (yearTo === yearFrom)
        return `${label} (${yearFrom})`;
    return `${label} (${yearFrom}${EN_DASH}${yearTo})`;
};
/** Inclusive; an open-ended generation covers every year from its start. */
export const generationCoversYear = ({ yearFrom, yearTo }, year) => year >= yearFrom && (yearTo === null || year <= yearTo);
//# sourceMappingURL=generations.js.map